import React, { useEffect } from "react";
import TitleBar from "../../components/common-components/TitleBar";
import Grid from "@mui/material/Grid2";
import DashBoradCard from "../../components/common-components/CustomCard";
import {
  CompanyIcon,
  DashboardAgentsIcon,
  DashboardOrdersIcon,
  DashboardUserIcon,
} from "../../assets/Icon/dashboredIcon";
import { useAppDispatch } from "../../stores/store";
import { getAdminData } from "../../stores/admin";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import { fullname } from "../../utils/StorageUtils";
import AdminChart from "../../components/common-components/AdminChart";

const AdminDashboard = () => {
  const dispatch = useAppDispatch();
  const { dataList, status } = useSelector((store: any) => store.admin);

  useEffect(() => {
    getAdminDataList();
  }, []);
  const getAdminDataList = async () => {
    try {
      await dispatch<any>(getAdminData({}));
    } catch (error) {}
  };
  if (status === "loading") {
    return (
      <Box>
        <ListLoadingNew />
      </Box>
    );
  }
  return (
    <>
      <TitleBar title={" Welcome,"} title1={fullname}></TitleBar>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <DashBoradCard
            icon={<DashboardUserIcon />}
            title="Total Clients"
            totalNumber={dataList?.total_clients}
            isAdminCard
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <DashBoradCard
            icon={<DashboardOrdersIcon />}
            title="Total Orders"
            totalNumber={dataList?.total_orders}
            isAdminCard
          />
        </Grid>
      </Grid>
      <AdminChart />
    </>
  );
};

export default AdminDashboard;
